"use strict";
/**
 * @license
 * SPDX-License-Identifier: Apache-2.0
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateRawMirroredCellCoordinates = void 0;
/**
 * Calculates the raw top-left coordinates for primary, X-mirrored, Y-mirrored,
 * and XY-mirrored grid cells, based on the logical grid.
 *
 * @param primaryTopLeftX - The absolute X pixel coordinate of the primary cell's top-left corner.
 * @param primaryTopLeftY - The absolute Y pixel coordinate of the primary cell's top-left corner.
 * @param cellPixelSize - The size of a flower grid cell in pixels.
 * @param gridData - The data defining the logical grid (offsets, number of columns/rows).
 * @returns An object containing the raw coordinates for primary, mirrorX, mirrorY, and mirrorXY cells.
 */
function calculateRawMirroredCellCoordinates(primaryTopLeftX, primaryTopLeftY, cellPixelSize, gridData) {
    if (cellPixelSize <= 0 || gridData.numCols <= 0 || gridData.numRows <= 0) {
        return {
            primary: { x: primaryTopLeftX, y: primaryTopLeftY },
            mirrorX: null,
            mirrorY: null,
            mirrorXY: null
        };
    }
    var results = {
        primary: { x: primaryTopLeftX, y: primaryTopLeftY },
        mirrorX: null,
        mirrorY: null,
        mirrorXY: null
    };
    // Convert primary cell's absolute pixel coordinates to 0-indexed col/row within the logical grid
    var primaryCol = Math.round((primaryTopLeftX - gridData.offsetX) / cellPixelSize);
    var primaryRow = Math.round((primaryTopLeftY - gridData.offsetY) / cellPixelSize);
    // Mirror column and row indices
    var mirrorXCol = gridData.numCols - 1 - primaryCol;
    var mirrorYRow = gridData.numRows - 1 - primaryRow;
    // Convert mirrored indices back to absolute pixel coordinates
    var mirrorX_TopLeftX = gridData.offsetX + mirrorXCol * cellPixelSize;
    results.mirrorX = { x: mirrorX_TopLeftX, y: primaryTopLeftY };
    var mirrorY_TopLeftY = gridData.offsetY + mirrorYRow * cellPixelSize;
    results.mirrorY = { x: primaryTopLeftX, y: mirrorY_TopLeftY };
    results.mirrorXY = { x: mirrorX_TopLeftX, y: mirrorY_TopLeftY };
    return results;
}
exports.calculateRawMirroredCellCoordinates = calculateRawMirroredCellCoordinates;
